import { render } from "./footer.html?vue&type=template&id=62f3e343&ts=true"
import script from "./footer.ts?vue&type=script&lang=ts"
export * from "./footer.ts?vue&type=script&lang=ts"

import "./footer.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__